import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useFormikContext } from 'formik'
import { CustomerAddress } from 'lib/types'
import { AddressSelector } from 'lib/modules/checkout'
import { Container } from './styled'

interface Props {
  address: CustomerAddress
  onSelect: ({ address }: { address: CustomerAddress }) => void
  isSelected: boolean
}

export const AddressPickerCard = ({ address, onSelect, isSelected }: Props) => {
  const { values, setValues } = useFormikContext<any>()

  const {
    id,
    firstName,
    lastName,
    company,
    street,
    street2,
    city,
    postalCode,
    regionCode,
    regionLabel,
    countryCode,
    phoneNumber
  } = address

  const handleSelect = () => {
    const newValues = {
      ...getValues(values),
      id,
      city,
      company,
      countryCode,
      firstName,
      lastName,
      postalCode,
      regionCode,
      street,
      street2,
      phoneNumber
    }
    setValues(newValues)
    // @ts-expect-error
    onSelect({ address: newValues }) // TODO: Fix types
  }

  useEffect(() => {
    if (isSelected) {
      handleSelect()
    }
    // eslint-disable-next-line
  }, [
    isSelected
  ])

  return (
    <AddressSelector isSelected={isSelected} onClick={handleSelect}>
      <Container onClick={handleSelect}>
        <p>{firstName} {lastName}</p>
        {company && (
          <p>{company}</p>
        )}
        <p>{street}</p>
        <p>{city}, {regionLabel}, {postalCode}, {countryCode}</p>
        {phoneNumber && (
          <p>
            <FormattedMessage
              id='customer.address.phoneNumberLabel'
              values={{
                phoneNumber
              }}
            />
          </p>
        )}
      </Container>
    </AddressSelector>
  )
}

const getValues = (values: Record<string, any>) => {
  const newValues: Record<string, any> = {}
  Object.keys(values).forEach(key => {
    if (values[key]) {
      newValues[key] = values[key]
    }
  })
  return newValues
}
